// extracted by mini-css-extract-plugin
export default {"text":"HintYouNeedStuff_text__mLpX9"};